import { Skeleton } from '../../../common/skeleton/Skeleton';
import styles from './InternalPaymentLoader.module.scss';

export const InternalPaymentLoader = () => (
  <div className={styles['internalPayment-loader']}>
    <div className={styles['internalPayment-loader-amount-wrapper']}>
      <Skeleton height="202" />
    </div>

    <div className={styles['internalPayment-loader-filterTabs']}>
      <Skeleton height="36" width="90" borderRadius="8" />
      <Skeleton height="36" width="90" borderRadius="8" />
      <Skeleton height="36" width="90" borderRadius="8" />
      <Skeleton height="36" width="90" borderRadius="8" />
    </div>

    {[1, 2, 3, 4, 5, 6, 7].map((key) => (
      <div key={key} className={styles['internalPayment-loader-listing']}>
        <Skeleton borderRadius="8" height="18" />
        <Skeleton borderRadius="8" width="200" height="18" />
      </div>
    ))}
  </div>
);
